import { render } from "./Create.vue?vue&type=template&id=8913f732"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import "./Create.vue?vue&type=style&index=0&id=8913f732&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__